import { Pipe, PipeTransform } from "@angular/core";
import { AccountMarketplace, AccountType, Brand } from "@front/m19-api-client";
import { SBStrategyLineCreative } from "@m19-board/strategies/strategy-grid/strategy-grid.service";

@Pipe({
  name: "strategyGridBrand",
})
export class StrategyGridBrandPipe implements PipeTransform {
  transform(creatives: SBStrategyLineCreative, accountMarketplace: AccountMarketplace, brands: Brand[]): string {
    if (accountMarketplace?.accountType == AccountType.VENDOR) {
      return (
        creatives?.productCollection?.[0]?.brandName ??
        creatives?.manualCollection?.[0]?.brandName ??
        creatives?.video?.[0]?.brandName ??
        ""
      );
    }
    const firstProduct = creatives?.productCollection?.[0]?.brandEntityId;
    const firstManual = creatives?.manualCollection?.[0]?.brandEntityId;
    const firstVideo = creatives?.video?.[0]?.brandEntityId;
    const firstStoreSpotlight = creatives?.storeSpotlight?.[0]?.brandEntityId;
    const firstBrandVideo = creatives?.brandVideo?.[0]?.brandEntityId;
    return (
      brands.find(
        (b) =>
          b.brandEntityId === firstProduct ||
          b.brandEntityId === firstManual ||
          b.brandEntityId === firstVideo ||
          b.brandEntityId === firstBrandVideo ||
          b.brandEntityId === firstStoreSpotlight,
      )?.brandName ?? ""
    );
  }
}
